import {texture} from "p3";
import definitions from "../../../definitions";
import Item from "./Item";

export default class ItemCollectionJarTrufflesFull extends Item {
    constructor() {
        super(definitions.ITEM_ID.COLLECTION_JAR_TRUFFLES_FULL, texture("prop_jar_of_truffles_00"));
    }

    init() {
        super.init();

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6, new PIXI.Point(3, 0));
    }
}